import { useEffect, useState } from 'react';

import EventCalendar from "components/calendar/EventCalendar";
import Event from "./components/Event";
import TimeLine from "./components/TimeLine";
import { FcGoogle } from "react-icons/fc";
import { TiVendorMicrosoft } from "react-icons/ti";
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import type { AppDispatch } from '../../../redux/store';
import { eventCustomers } from '../../../redux/eventSlice';
import EventTypesCard from '../inbox/EventTypesCard';

type EventDetails = {
  phoneNumber: string;
  eventId: string;
  fromTimezone: string;
  toTimezone: string;
  acceptTerms: boolean;
  time: string;
  eventEmail: string;
  user_email: string;
  name: string;
  customerId: string;
  hours: string;
  day: string;
  weekday: string;
  start: string;
  title:string;
};
// eventCustomers
const Calendar = () => {

    const customers = useSelector((state: RootState) => state.event.eventCustomers); 
    const [timeLineEventDetails, setTimeLineEventDetails] = useState([]);

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
      dispatch(eventCustomers());
    }, [dispatch]);

    const eventCustomer:EventDetails[] = customers ? customers : [];
    const transformedEvents = eventCustomer.map(event => {
      const eventDetails:EventDetails = event;
      console.log(eventDetails);
      return {
          title:  eventDetails.hours,
          name:eventDetails.name,
          email:eventDetails.user_email,
          borderColor: 'transparent',
          start:  eventDetails.start,
          backgroundColor: '#FFFFFF',
          className: 'info',
          details: {
              title:  eventDetails.name,
              email:eventDetails.user_email,
              day:  eventDetails.day,
              weekday: eventDetails.weekday,
              hours: eventDetails.hours
          }
      };
  });
  
  console.log(transformedEvents);

  const handleDateClick = (arg: any) => { 
    const selectedDate = arg.dateStr;

    // Filter the events based on the selected date
    const filteredEvents = transformedEvents.filter(event => event.start === selectedDate);

    // Map to get the details of each event
    const eventDetails = filteredEvents.map(event => event.details);

    // Do something with the event details, like setting state or logging
    setTimeLineEventDetails(eventDetails);
};

  return (
    <div className="mt-3 grid h-full w-full grid-cols-11 gap-5 rounded-[20px]">
      <div className="col-span-11">
        <EventTypesCard />
      </div>
  
      {/* Calendar */}
      <div className="z-0 col-span-11 h-full w-full rounded-[20px] bg-white bg-clip-border px-[24px] py-[20px] shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none lg:col-span-7">
   
        <div className="mt-[28px] h-[700px] w-full rounded-[20px] dark:text-white">
          <EventCalendar initialDate="2022-10-01" calendarData={transformedEvents}  handleDateClick={handleDateClick} />
          <div className="mt-[28px] h-[10px] w-full rounded-[20px] dark:text-white">
          <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800 dark:text-white" >
              <div className="rounded-full text-xl">
                <FcGoogle />
              </div>
              <p className="text-sm font-medium text-navy-700 dark:text-white">
              Connect Gmail calendar & Send Email
              </p>
            </div>
            <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800">
              <div className="rounded-full text-xl">
                <TiVendorMicrosoft className="microsoft-logo" size={30} />
              </div>
              <h5 className="text-sm font-medium text-navy-700 dark:text-white">
              Connect Microsoft calendar & Send Email
 
              </h5>
          </div>
      </div>
        </div>
   
      </div>
      <div className="b col-span-11 w-full rounded-[20px] lg:col-span-4">
        <div>
        {timeLineEventDetails && timeLineEventDetails.length > 0 && (
          <TimeLine eventDetails={timeLineEventDetails} />
        )}
        </div>
     
      </div>
    </div>
  );
};

export default Calendar;
